import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { style: {"transform-origin":"center"} }, [
      _createElementVNode("path", {
        d: "M10.0002 2.5V5M10.0002 15V17.5M4.69695 4.6967L6.46471 6.46447M13.5358 13.5355L15.3035 15.3033M2.5 10.0006H5M15 10.0006H17.5M4.69695 15.3033L6.46471 13.5355M13.5358 6.46447L15.3035 4.6967",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }),
      _createElementVNode("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0",
        to: "360",
        begin: "0s",
        dur: "3s",
        repeatCount: "indefinite"
      })
    ], -1)
  ]))]))
}
export default { render: render }